(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  // FAQ Accordion functionality
  document.addEventListener('DOMContentLoaded', function() {
    const faqSections = document.querySelectorAll('[data-section-type="faq"]');
    
    faqSections.forEach(section => {
      const buttons = section.querySelectorAll('[data-faq-button]');
      
      buttons.forEach(button => {
        button.addEventListener('click', (e) => {
          // Check if the click target or any parent is an anchor link
          const clickedAnchor = e.target.closest('a');
          if (clickedAnchor) {
            // Allow default anchor behavior, don't toggle FAQ item
            return;
          }
          
          e.preventDefault();
          toggleFAQItem(button.closest('[data-faq-item]'), section);
        });
      });
    });
  });

  function toggleFAQItem(item, section) {
    const isOpen = item.getAttribute('data-open') === 'true';
    
    // Close all other items in this section (accordion behavior)
    const allItems = section.querySelectorAll('[data-faq-item]');
    allItems.forEach(otherItem => {
      if (otherItem !== item) {
        otherItem.setAttribute('data-open', 'false');
      }
    });
    
    // Toggle current item
    item.setAttribute('data-open', !isOpen);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog-post"] && !Shopify.designMode) return;
  try {
    
class FeaturedBlogPost extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.loadingIndicator = this.querySelector('.featured-blog-post__loading');
    this.contentContainer = this.querySelector('.page-width');
    this.section = this.parentElement;
    
    // Store bound functions for proper cleanup
    this.boundFunctions = {
      updateContent: this.updateContent.bind(this)
    };
    
    this.init();
  }
  
  init() {
    if (!this.sectionId) {
      console.error('Featured blog post section ID not found');
      return;
    }
    
    // Listen for blog navigation changes
    document.addEventListener('blog-navigation-changed', this.boundFunctions.updateContent);
  }
  
  async updateContent(event) {
    try {
      // Check if component is still connected
      if (!this.isConnected) {
        return;
      }
      
      // Extract URL from event detail
      const url = event.detail.url;
      
      // Show loading state
      this.showLoading();
      
      const sectionUrl = `${url}?section_id=${this.sectionId}`;
      const response = await fetch(sectionUrl);
      const html = await response.text();
      
      // Check if component is still connected after async operation
      if (!this.isConnected) {
        return;
      }
      
      // Store scroll position right before content update
      const currentScrollY = window.scrollY;
      
      // Parse the response to get the section content
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector(`[data-section-id="${this.sectionId}"]`);
      
      if (newContent) {
        // Update this section's content
        this.section.innerHTML = newContent.innerHTML;
        
        // Restore scroll position to prevent jumping
        window.scrollTo(0, currentScrollY);
        
        // Re-initialize any components that might need it
        this.reinitializeComponents();
      }
    } catch (error) {
      console.error('Error updating featured blog post:', error);
    } finally {
      // Only hide loading if component is still connected
      if (this.isConnected) {
        this.hideLoading();
      }
    }
  }
  
  reinitializeComponents() {
    // Re-initialize any components that were replaced
    // This might include lazy loading, event listeners, etc.
    if (typeof window.lazyLoad !== 'undefined') {
      window.lazyLoad.update();
    }
  }
  
  showLoading() {
    if (this.loadingIndicator) {
      this.loadingIndicator.style.display = 'flex';
    }
    if (this.contentContainer) {
      this.contentContainer.style.opacity = '0.5';
    }
  }
  
  hideLoading() {
    if (this.loadingIndicator) {
      this.loadingIndicator.style.display = 'none';
    }
    if (this.contentContainer) {
      this.contentContainer.style.opacity = '1';
    }
  }

  disconnectedCallback() {
    // Remove document-level event listeners
    if (this.boundFunctions) {
      document.removeEventListener('blog-navigation-changed', this.boundFunctions.updateContent);
    }
    
    // Clear references
    this.loadingIndicator = null;
    this.contentContainer = null;
    this.boundFunctions = null;
  }
}

// Register the custom element
if (!customElements.get('featured-blog-post')) {
  console.log('featured blog post custom element');
  customElements.define('featured-blog-post', FeaturedBlogPost);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
class ShpfltBlogNavigation extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.blog__navigation-container');
    this.navItems = this.querySelectorAll('.blog__nav-item');
    this.loadingIndicator = document.querySelector('.blog__loading');
    this.currentTags = this.getCurrentTags();
    
    
    // Get blog URL from data attribute
    this.blogUrl = this.getAttribute('data-blog-url');
    
    // Get the actual section ID from the data attribute
    this.sectionId = this.getSectionId();
    
    // Store bound functions for proper cleanup
    this.boundFunctions = {
      handleTagClick: this.handleTagClick.bind(this),
      handleArticleTagClick: this.handleArticleTagClick.bind(this),
      loadSectionContent: this.loadSectionContent.bind(this)
    };
    
    // Store event handlers for proper removal
    this.eventHandlers = {
      navItemClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.boundFunctions.handleTagClick(e.currentTarget);
      },
      articleTagClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.boundFunctions.handleArticleTagClick(e.currentTarget);
      }
    };
    
    this.init();
  }
  
  getSectionId() {
    // Find the blog section and get its data-section-id
    const blogSection = document.querySelector('[data-section-type="blog"]');
    if (blogSection) {
      return blogSection.getAttribute('data-section-id');
    }
    
    // Fallback: look for any section with main-blog type
    const mainBlogSection = document.querySelector('[data-section-type="main-blog"]');
    if (mainBlogSection) {
      return mainBlogSection.getAttribute('data-section-id');
    }
    
    console.warn('Could not find blog section ID');
    return null;
  }
  
  init() {
    if (!this.sectionId) {
      console.error('Section ID not found, navigation disabled');
      return;
    }
    
    if (!this.blogUrl) {
      console.error('Blog URL not found, navigation disabled');
      return;
    }
    
    // Ensure active states are correct on initial load
    // The HTML from server should already have correct active classes,
    // but we sync them with current URL to be sure
    this.updateActiveStates();
    
    this.bindEvents();
    this.bindArticleTagLinks();
  }
  
  getCurrentTags() {
    // Parse tags from URL path like /blogs/journal/tagged/espana+mexico
    const path = window.location.pathname;
    const taggedMatch = path.match(/\/tagged\/(.+)$/);
    
    if (taggedMatch) {
      return taggedMatch[1].split('+');
    }
    
    return [];
  }
  
  bindEvents() {
    if (this.navItems && this.eventHandlers) {
      this.navItems.forEach((item, index) => {
        item.addEventListener('click', this.eventHandlers.navItemClick);
      });
    }
  }
  
  bindArticleTagLinks() {
    // First unbind old article tag link events to prevent duplicates
    this.unbindArticleTagLinks();
    
    // Find article tag links in the parent blog section
    const blogSection = document.querySelector('[data-section-type="main-blog"]');
    if (blogSection && this.eventHandlers) {
      const tagLinks = blogSection.querySelectorAll('.blog__article-tag-link');
      tagLinks.forEach(link => {
        link.addEventListener('click', this.eventHandlers.articleTagClick);
      });
    }
  }
  
  handleArticleTagClick(link) {
    const url = link.getAttribute('href');
    
    // Extract tag handle from URL (format: /blogs/journal/tagged/tag-handle)
    const tagMatch = url.match(/\/tagged\/([^\/]+)$/);
    if (!tagMatch || !this.blogUrl) {
      // Fallback to normal behavior if URL format is unexpected or blogUrl is missing
      this.loadSectionContent(url);
      return;
    }
    
    const clickedTagHandle = tagMatch[1];
    const hasActiveTags = this.currentTags.length > 0;
    
    // If there are active tags, use smart fallback logic
    if (hasActiveTags) {
      // Build combined URL with current tags + new tag
      const currentTagHandles = this.currentTags.join('+');
      const combinedUrl = `${this.blogUrl}/tagged/${currentTagHandles}+${clickedTagHandle}`;
      const replacementUrl = url; // URL already contains only the clicked tag
      this.loadWithFallback(combinedUrl, replacementUrl);
    } else {
      // No active tags, use normal behavior
      this.loadSectionContent(url);
    }
  }
  
  handleTagClick(item) {
    const tag = item.dataset.tag;
    
    if (tag === 'all') {
      this.navigateToUrl(this.blogUrl);
      return;
    }
    
    // Check if tag is currently active (removing) or inactive (adding)
    const isActive = item.classList.contains('active');
    const hasActiveTags = this.currentTags.length > 0;
    
    // If adding a tag and there are already active tags, use smart fallback logic
    if (!isActive && hasActiveTags) {
      const combinedUrl = item.getAttribute('href');
      const replacementUrl = this.generateReplacementUrl(tag);
      if (combinedUrl && replacementUrl) {
        this.loadWithFallback(combinedUrl, replacementUrl);
      } else {
        // Fallback to normal behavior if URLs are invalid
        const url = item.getAttribute('href');
        this.navigateToUrl(url);
      }
    } else {
      // Use normal behavior: removing tag or no active tags
      const url = item.getAttribute('href');
      this.navigateToUrl(url);
    }
  }
  
  generateReplacementUrl(tagHandle) {
    // Generate URL with only the clicked tag (replacing current active tags)
    if (!this.blogUrl) {
      return null;
    }
    return `${this.blogUrl}/tagged/${tagHandle}`;
  }
  
  async checkSectionHasResults(url) {
    // Silent check: fetch and verify if there are articles, without updating DOM or firing events
    try {
      const sectionUrl = `${url}?section_id=${this.sectionId}`;
      const response = await fetch(sectionUrl);
      const html = await response.text();
      
      // Parse the response to check for articles
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Find the section content by the specific section ID
      const sectionContent = doc.querySelector(`[data-section-id="${this.sectionId}"]`);
      
      if (sectionContent) {
        // Check if there are any articles in the blog__articles container
        const articlesContainer = sectionContent.querySelector('.blog__articles');
        if (articlesContainer) {
          const articles = articlesContainer.querySelectorAll('.blog__article');
          return articles.length > 0;
        }
      }
      
      return false;
    } catch (error) {
      console.error('Error checking section results:', error);
      // If check fails, assume no results to trigger fallback
      return false;
    }
  }
  
  async loadWithFallback(combinedUrl, replacementUrl) {
    // Validate URLs
    if (!combinedUrl || !replacementUrl) {
      console.error('Invalid URLs for fallback loading');
      return;
    }
    
    // First check if combined filters have results
    const hasResults = await this.checkSectionHasResults(combinedUrl);
    
    if (hasResults) {
      // Combined filters have results, load normally
      this.loadSectionContent(combinedUrl);
    } else {
      // Combined filters have no results, use replacement URL (toggle behavior)
      this.loadSectionContent(replacementUrl);
    }
  }
  
  navigateToUrl(url) {
    // Use section rendering API for AJAX navigation
    this.loadSectionContent(url);
  }
  
  async loadSectionContent(url) {
    try {
      // Store scroll position right before content update
      const currentScrollY = window.scrollY;
      // Show loading state
      this.showLoading();
      
      // Add section_id parameter for section rendering
      const sectionUrl = `${url}?section_id=${this.sectionId}`;

      // Emit custom event for other sections to listen
      document.dispatchEvent(new CustomEvent('blog-navigation-changed', {
        detail: { url: url },
        bubbles: true // Allow event to bubble up
      }));

      
      const response = await fetch(sectionUrl);
      const html = await response.text();
      

      
      // Parse the response to get only the section content
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Find the section content by the specific section ID
      const sectionContent = doc.querySelector(`[data-section-id="${this.sectionId}"]`);
      
      // Update URL BEFORE replacing HTML so the new component reads correct URL
      window.history.pushState({}, '', url);
      
      if (sectionContent) {
        // Update the current section with new content
        const currentSection = document.querySelector(`[data-section-id="${this.sectionId}"]`);
        if (currentSection) {
          currentSection.innerHTML = sectionContent.innerHTML;
        }
      }
      
      // Restore scroll position to prevent jumping
      window.scrollTo(0, currentScrollY);
      
      // Check if component is still connected before trying to update
      // Note: After HTML replacement, a new component instance is created
      // The connectedCallback() of the new instance will handle updating active states
      if (this.isConnected) {
        // Update current tags from the new URL (after pushState)
        this.currentTags = this.getCurrentTags();
        
        // Try to update active states, but new component's connectedCallback will also do this
        this.updateActiveStates();
        
        // Re-initialize any components that might need it
        this.reinitializeComponents();
      }
      
    } catch (error) {
      console.error('Error loading section content:', error);
      // Fallback to regular navigation
      window.location.href = url;
    } finally {
      // Only hide loading if component is still connected
      if (this.isConnected) {
        this.hideLoading();
      }
    }
  }
  
  updateActiveStates() {
    // Update navigation items after content replacement
    this.navItems = this.querySelectorAll('.blog__nav-item');
    
    // Ensure currentTags is up to date
    this.currentTags = this.getCurrentTags();
    
    this.navItems.forEach(item => {
      const tag = item.dataset.tag;
      
      // Remove active class from all items
      item.classList.remove('active');
      
      // Add active class to "ver todas" if no tags are selected
      if (tag === 'all' && this.currentTags.length === 0) {
        item.classList.add('active');
      }
      // Add active class to tag items that are currently selected
      else if (tag !== 'all' && this.currentTags.includes(tag)) {
        item.classList.add('active');
      }
    });
  }

  reinitializeComponents() {
    // Re-initialize any components that were replaced
    // This might include lazy loading, event listeners, etc.
    if (typeof window.lazyLoad !== 'undefined') {
      window.lazyLoad.update();
    }
    
    // Re-bind article tag links after content update
    this.bindArticleTagLinks();
  }
  
  showLoading() {
    if (this.loadingIndicator) {
      this.loadingIndicator.style.display = 'flex';
    }
    // Disable navigation items during loading
    if (this.navItems) {
      this.navItems.forEach(item => {
        item.style.pointerEvents = 'none';
        item.style.opacity = '0.5';
      });
    }
  }
  
  hideLoading() {
    if (this.loadingIndicator) {
      this.loadingIndicator.style.display = 'none';
    }
    
    // Re-enable navigation items and re-bind events
    this.navItems = this.querySelectorAll('.blog__nav-item');
    if (this.navItems) {
      this.navItems.forEach(item => {
        item.style.pointerEvents = 'auto';
        item.style.opacity = '1';
      });
    }
    
    // Re-bind events to new navigation items (only if component is still connected)
    if (this.isConnected) {
      this.bindEvents();
    }
  }
  
  unbindEvents() {
    // Remove navigation item event listeners
    if (this.navItems && this.eventHandlers) {
      this.navItems.forEach((item, index) => {
        item.removeEventListener('click', this.eventHandlers.navItemClick);
      });
    }
  }
  
  unbindArticleTagLinks() {
    // Find and remove article tag link event listeners
    const blogSection = document.querySelector('[data-section-type="main-blog"]');
    if (blogSection && this.eventHandlers) {
      const tagLinks = blogSection.querySelectorAll('.blog__article-tag-link');
      tagLinks.forEach((link, index) => {
        link.removeEventListener('click', this.eventHandlers.articleTagClick);
      });
    }
  }

  connectedCallback() {
    // When component is connected to DOM, ensure active states are correct
    // This is important after HTML replacement when component is recreated
    // Use a small delay to ensure URL is updated after pushState
    setTimeout(() => {
      if (this.isConnected && this.navItems && this.navItems.length > 0) {
        // Update current tags from URL (may have changed since constructor)
        this.currentTags = this.getCurrentTags();
        // Update active states to match current URL
        this.updateActiveStates();
      }
    }, 0);
  }

  disconnectedCallback() {
    // Unbind all event listeners
    this.unbindEvents();
    this.unbindArticleTagLinks();
    
    // Remove document-level event listeners
    document.removeEventListener('blog-navigation-changed', this.boundFunctions.loadSectionContent);
    
    // Clear references
    this.loadingIndicator = null;
    this.navItems = null;
    this.boundFunctions = null;
    this.eventHandlers = null;
    
  }
}

if (!customElements.get('shpflt-blog-navigation')) {
  customElements.define('shpflt-blog-navigation', ShpfltBlogNavigation);
}


  } catch(e) { console.error(e); }
})();
})();
